export const formatName = (person, isSnake = false, emptyStr='') => {
    if (!person) return emptyStr;
    const formattedStr = isSnake ?
        `${person?.first_name || ''} ${person?.last_name || ''}` :
        `${person?.firstName || ''} ${person?.lastName || ''}`;
    return formattedStr.trim();
};

export const formatInitials = (person, isSnake=false, emptyStr='') => {
    if (!person) return emptyStr;
    const formattedStr = isSnake ?
        `${person?.first_name.charAt(0) || ''}${person?.last_name.charAt(0) || ''}` :
        `${person?.firstName.charAt(0) || ''}${person?.lastName.charAt(0) || ''}`;
    return formattedStr.trim().toUpperCase();
}
